import React from "react";
import { Brain, MapPin, Heart, Target, Activity, MessageSquareText } from "lucide-react";

const ROWS = [
  { key: "confirmedFacts", label: "Confirmed facts", icon: MapPin },
  { key: "preferences", label: "Preferences", icon: Heart },
  { key: "behaviorSignals", label: "Behavior signals", icon: Activity },
  { key: "openGoals", label: "Open goals", icon: Target },
];

export default function MemoryCard({ memory, compact }) {
  if (!memory) return null;
  const has = ROWS.some((r) => (memory[r.key] || []).length) || memory.summary || memory.communicationStyle;
  if (!has) return null;
  return (
    <div className="p-4" style={{ background: "var(--s2)", border: "1px solid var(--border)" }} data-testid="memory-card">
      <div className="flex items-center gap-2 mb-3">
        <Brain size={15} style={{ color: "var(--accent-2)" }} />
        <span className="heading-eyebrow">Relationship memory</span>
        <span className="mono text-[10px]" style={{ color: "var(--text-muted)" }}>via Cognee</span>
      </div>
      {memory.summary && <p className="text-sm mb-3" style={{ color: "var(--text-2)" }}>{memory.summary}</p>}
      <div className="space-y-2.5">
        {ROWS.map((r) => {
          const vals = memory[r.key] || [];
          if (!vals.length) return null;
          return (
            <div key={r.key} className="flex gap-2.5" data-testid={`memory-${r.key}`}>
              <r.icon size={14} style={{ color: "var(--text-muted)", flexShrink: 0, marginTop: 2 }} />
              <div className="flex-1">
                <div className="text-[11px] mb-1" style={{ color: "var(--text-muted)" }}>{r.label}</div>
                <div className="flex flex-wrap gap-1.5">
                  {vals.map((v, i) => (
                    <span key={i} className="tag" style={{ fontSize: 11 }}>{v}</span>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
        {memory.communicationStyle && (
          <div className="flex gap-2.5">
            <MessageSquareText size={14} style={{ color: "var(--text-muted)", flexShrink: 0, marginTop: 2 }} />
            <div>
              <div className="text-[11px] mb-1" style={{ color: "var(--text-muted)" }}>Communication style</div>
              <span className="text-sm" style={{ color: "var(--text-2)" }}>{memory.communicationStyle}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
